import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import img1 from "../assets/images/sistemas-de-reserva.jpeg";
import img2 from "../assets/images/integração-whatsapp.jpeg";
import img3 from "../assets/images/loja-online.jpeg";
import img4 from "../assets/images/google-maps.jpeg";

const slides = [
  {
    title: "Sistema de Reservas",
    desc: "Os clientes podem marcar diretamente no seu website, escolher datas e receber confirmação automática.",
    image: img1,
  },
  {
    title: "Integração WhatsApp",
    desc: "Botão de contacto sempre visível para aumentar pedidos de informação.",
    image: img2,
  },
  {
    title: "Loja Online",
    desc: "Venda produtos ou serviços diretamente através do website.",
    image: img3,
  },
  {
    title: "Google Maps",
    desc: "Ajude os clientes a encontrar facilmente o seu negócio.",
    image: img4,
  },
];

export default function ExamplesCarousel() {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  const startAutoPlay = () => {
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
  };

  useEffect(() => {
    startAutoPlay();

    return () => clearInterval(intervalRef.current);
  }, []);

  const next = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
    startAutoPlay();
  };

  const previous = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
    startAutoPlay();
  };

  const slide = slides[current];

 return (
  <section className="mt-20">

    <div className="mb-10 max-w-2xl">
      <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">
        Funcionalidades em ação
      </span>

      <h2 className="mt-4 font-display text-4xl font-semibold text-ink sm:text-5xl">
        Ferramentas pensadas para fazer crescer o seu negócio
      </h2>

      <p className="mt-4 text-muted-foreground">
        Explore algumas das funcionalidades que podemos integrar no seu website.
      </p>
    </div>

    <div className="grid items-center gap-16 rounded-[2rem] border border-transparent bg-tint p-10 shadow-xl lg:grid-cols-[0.9fr_1.1fr]">

      {/* Texto */}

      <div>

        <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">
          EXEMPLO
        </span>

        <h3 className="mt-3 font-display text-4xl font-semibold text-ink">
          {slide.title}
        </h3>

        <p className="mt-5 text-lg leading-relaxed text-muted-foreground">
          {slide.desc}
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">

         <div className="flex items-center gap-3 rounded-xl bg-white shadow-md p-3">
           <span className="text-grad font-bold">✓</span>
           <span>Fácil de utilizar</span>
         </div>

         <div className="flex items-center gap-3 rounded-xl bg-white shadow-md p-3">
           <span className="text-grad font-bold">✓</span>
           <span>Totalmente personalizável</span>
         </div>

         <div className="flex items-center gap-3 rounded-xl bg-white shadow-md p-3">
           <span className="text-grad font-bold">✓</span>
           <span>Design profissional</span>
         </div>

         <div className="flex items-center gap-3 rounded-xl bg-white shadow-md p-3">
           <span className="text-grad font-bold">✓</span>
           <span>Funciona em qualquer dispositivo</span>
         </div>

        </div>

      </div>

      {/* Imagem */}

      <div className="relative">

         <motion.img
           key={current}
           src={slide.image}
           alt={slide.title}
           initial={{ opacity: 0, scale: 1.05 }}
           animate={{ opacity: 1, scale: 1 }}
           transition={{ duration: 0.45 }}
           className="w-full aspect-[16/9] object-cover rounded-2xl shadow-xl"
         />

         <button
           onClick={previous}
           className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-3 shadow-lg transition hover:scale-110"
         >
           <ChevronLeft size={22} />
         </button>

         <button
           onClick={next}
           className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-3 shadow-lg transition hover:scale-110"
         >
           <ChevronRight size={22} />
         </button>

         <div className="mt-6 flex justify-center gap-3">

           {slides.map((_, index) => (

             <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`h-3 w-3 rounded-full transition-all ${
                    current === index
                        ? "w-8 bg-grad"
                        : "bg-gray-300"
                }`}
             />

           ))}

         </div>

      </div>
    </div>

  </section>
 );
}